import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  width: 100%;

  @media (max-width: 48rem) {
    flex-direction: column;
  }
`

export const Card = styled.div<{ $hasOnClick?: boolean }>`
  background-color: ${(p) => p.theme.colors.turquoiseDark};
  padding: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 17rem;
  min-height: 15rem;
  cursor: ${(p) => p.$hasOnClick ? 'pointer' : 'default'};
  transition: transform 0.2s ease;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 0.8rem;
  position: relative;

  ${(p) => p.$hasOnClick && `
    &:hover {
      transform: scale(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  `}
`

export const Title = styled.h2`
  color: white;
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0 0 2rem 0;
  text-align: center;
`

export const Value = styled.div`
  margin-top: 2rem;
  color: white;
  font-size: 5.5rem;
  font-weight: 900;
  letter-spacing: 0.05em;

  @media (max-width: 48rem) {
    font-size: 2.5rem;
  }

  @media (max-width: 75rem) {
    font-size: 3.5rem;
  }
`

export const Currency = styled.span`
  font-size: 1.5rem;
  margin-left: 0.5rem;
  opacity: 0.9;
`

export const InfoIconWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;

  /* Override SVG styles */
  svg {
    fill: white !important;
  }
`

export const ComparisonIndicator = styled.div<{ $isPositive: boolean }>`
  position: absolute;
  top: 0.2rem;
  right: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem 0.8rem;
  font-size: 1.3rem;
  font-weight: 600;
  transition: all 0.2s ease;
  z-index: 10;
  color: ${(p) => p.theme.colors.white};

  svg {
    height: 1.5rem;
    fill: ${(p) => p.theme.colors.white};
    margin-left: 0.3rem;
  }



  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 48rem) {
    font-size: 0.9rem;
    padding: 0.3rem 0.6rem;
  }

  @media (max-width: 75rem) {
    font-size: 0.95rem;
    padding: 0.35rem 0.7rem;
  }
`
